// import request from "./api";

export const lazyload = function (time: number) {
  if (!time) time = 50;
  let timeObj: any;
  return function (cb: any, time2 = time) {
    if (typeof cb != "function")
      return;
    clearInterval(timeObj);
    timeObj = setTimeout(cb, time2);
  }
};

//节流加载( 规定时间内只执行最早的一次)
export const throttleLoad = function (duration: number) { //duration 单位:毫秒
  if (!duration) {
    duration = 200;
  }
  let last: any
  return function (cb: any, duration2 = duration) {
    let now = Date.now()
    if (last && (now - last) < duration2) return
    last = now
    typeof cb == 'function' && cb();
  }
}

export const format = function (date: Date, fmt: string) {
  var o: any = {
    "M+": date.getMonth() + 1, //月份 
    "d+": date.getDate(), //日 
    "h+": date.getHours(), //小时 
    "m+": date.getMinutes(), //分 
    "s+": date.getSeconds(), //秒 
    "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
    "S": date.getMilliseconds() // 毫秒
  };

  // 根据y的长度来截取年
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  }
  return fmt;
}

// String.prototype['dateformat'] = function (format: string) {
//   let str = this.toString()


//   if (str.indexOf('T') == -1) {
//     str = str.replace(/-/g, '/')
//   }
//   else {
//     str = str.replace('T', ' ').replace(/-/g, '/')
//   }
//   let date: any = new Date(str)
//   if (format) {
//     return date.format(format)
//   }
//   else {
//     return str
//   }
// }

// Date.prototype['format'] = function (format: string): string {

//   let date = this
//   var map = {
//     "M": date.getMonth() + 1, //月份
//     "d": date.getDate(), //日
//     "h": date.getHours(), //小时
//     "m": date.getMinutes(), //分
//     "s": date.getSeconds(), //秒
//     "q": Math.floor((date.getMonth() + 3) / 3), //季度
//     "S": date.getMilliseconds() //毫秒
//   };
//   format = format.replace(/([yMdhmsqS])+/g, (all, t) => {
//     var v = map[t];
//     if (v !== undefined) {
//       if (all.length > 1) {
//         v = '0' + v;
//         v = v.substr(v.length - 2);
//       }
//       return v;
//     } else if (t === 'y') {
//       return (date.getFullYear() + '').substr(4 - all.length);
//     }
//     return all;
//   });
//   return format;
// }



// Array.prototype['distinct'] = function (key: string): any {
//   var result = [];
//   var obj = {};
//   for (var i = 0; i < this.length; i++) {
//     if (!obj[this[i][key]]) {
//       result.push(this[i]);
//       obj[this[i][key]] = true;
//     }
//   }
//   return result
// }


// Array.prototype['select'] = function (name: string) {
//   if ((this) instanceof Array) {
//     let arrs = [];
//     for (var i = 0; i < this.length; i++) {
//       if (this[i][name] != undefined) {
//         arrs.push(this[i][name]);
//       }
//     }
//     return arrs.toString();
//   }
//   return "";
// }


export function showDate(date1: string, date2?: string, format: string = 'yyyy-MM-dd', format2 = 'hh:mm') {
  if (!date1 || !date2) {
    return ''
  }
  let startDate: any = date1
  let endtDate: any = date2

  let t1 = startDate.dateformat('yyyy-MM-dd')
  let t2 = startDate.dateformat(format2)
  let t3 = endtDate.dateformat('yyyy-MM-dd')
  let t4 = endtDate.dateformat(format2)

  if (format) {
    t1 = startDate.dateformat(format)
    t3 = endtDate.dateformat(format)
  }

  return t1 == t3 ? `${t1} ${t2} - ${t4}` : `${t1} ${t2} 至 ${t3} ${t4}`
}

export function time(nS: any) {
  let viewtime = new Date(parseInt(nS) * 1000)
  let result: any
  let viewtimeArr;
  viewtimeArr = [viewtime.getFullYear(), viewtime.getMonth() + 1, viewtime.getDate()]
  let nowDate = new Date()
  let year = nowDate.getFullYear()
  let month = nowDate.getMonth() + 1;
  let day = nowDate.getDate()

  if (year == viewtimeArr[0]) {
    if (month == viewtimeArr[1] && day - viewtimeArr[2] < 2) {
      if (day - viewtimeArr[2] === 1)
        result = `昨天`
      else result = `今天`
    } else {
      result = `${viewtimeArr[1]}-${viewtimeArr[2]}`
    }
  } else {
    result = `${viewtimeArr[0]}-${viewtimeArr[1]}-${viewtimeArr[2]}`
  }
  // console.log(viewtime, year, month, day, viewtimeArr)
  return result
}

export const isArray = function (value: any) {
  if (typeof Array.isArray === "function") {
    return Array.isArray(value);
  } else {
    return Object.prototype.toString.call(value) === "[object Array]";
  }
}